import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, InputNumber, Switch, Select } from 'antd';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'name', label: 'Name', required: true },
  { key: 'description', label: 'Description', textarea: true, rows: 3 },
  // The paywall's benefit tiles, "value|label" each; translated like the name.
  { key: 'features', label: 'Features', placeholder: 'Type a feature and press Enter', tags: true },
];

export const SubscriptionPlanEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({ resource: 'subscription-plans' });

  return (
    <Edit resource="subscription-plans" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeTranslations(values.translations, LANG_FIELDS, queryResult?.data?.data?.translations),
          })
        }
      >
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Plan Type" name="planType" rules={[{ required: true }]}>
          <Select
            options={[
              { label: 'Free', value: 'FREE' },
              { label: 'Basic', value: 'BASIC' },
              { label: 'Pro', value: 'PRO' },
              { label: 'Premium', value: 'PREMIUM' },
              { label: 'Enterprise', value: 'ENTERPRISE' },
            ]}
          />
        </Form.Item>
        <Form.Item label="Monthly Price (cents)" name="priceMonthlyCents" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Yearly Price (cents)" name="priceYearlyCents">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Currency" name="currency">
          <Input />
        </Form.Item>
        <Form.Item label="Trial Days" name="trialDays">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Sort Order" name="sortOrder">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item label="Provider Product ID" name="providerProductId">
          <Input />
        </Form.Item>
        <Form.Item label="Provider Price ID" name="providerPriceId">
          <Input />
        </Form.Item>
      </Form>
    </Edit>
  );
};
